<script>
    import { mapState } from 'vuex';

    export default {
        name: "BlogAboveTheFoldComponent",
        data () {
            return {
                componentType: "blogAboveTheFold"
            }
        },
        computed: {
            ...mapState('pages', ['pageData']),
            availableTemplates () {
                return [
                    {
                        templateFilename: "blogAboveTheFoldTemplate1",
                        forSectionTemplates: ['BlogAboveTheFold1'],
                    },
                    {
                        templateFilename: "blogAboveTheFoldTemplate2",
                        forSectionTemplates: ['BlogAboveTheFold2'],
                    },
                    {
                        templateFilename: "blogAboveTheFoldTemplate3",
                        forSectionTemplates: ['BlogAboveTheFold3'],
                    },
                    {
                        templateFilename: "blogAboveTheFoldTemplate4",
                        forSectionTemplates: ['BlogAboveTheFold4'],
                    },
                    {
                        templateFilename: "blogAboveTheFoldTemplate5",
                        forSectionTemplates: ['BlogAboveTheFold5'],
                    },
                    {
                        templateFilename: "blogAboveTheFoldTemplate6",
                        forSectionTemplates: ['BlogAboveTheFold6'],
                    },
                ]
            },
            getDefaultTemplate () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;

                let template = this.availableTemplates.find(template => template.forSectionTemplates.includes(sectionTemplateId));

                if (sectionState && template) {
                    return template.templateFilename;
                }

                return this.availableTemplates[0] ? this.availableTemplates[0].templateFilename : "";
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    itemVisibilitySettings: null,
                    template: this.getDefaultTemplate,
                };
            },
            myBlogPostData () {
                if (!this.pageData || this.pageData.type !== 'blog_post') {
                    return null;
                }

                return {
                    title: this.pageData.title || '',
                    author_name: this.pageData.author_name || '',
                    image: this.pageData.image || '',
                    published: this.pageData.published || null, // published comes as timestamp
                    categories: this.pageData.categories || [],
                    description: this.pageData.description || '',
                    slug: this.pageData.slug,
                }
            },
        },
        methods: {
            prepareBlogPostDataToRender (blogPostData) {
                let newData = copyJson(blogPostData);

                if (newData.published) {
                    newData.date = this.i18n.formatTimestampLocalized(newData.published, "MMMM D, YYYY");
                    newData.shortDate = newData.date.split(",")[0];
                }

                if (newData.image) {
                    newData.fullImagePath = newData.image;
                } else if (newData.seo && newData.seo.image) {
                    newData.fullImagePath = newData.seo.image;
                } else {
                    newData.fullImagePath = window.imagePath + "/images/default_blog-post_image.jpg";
                }

                return newData;
            },
            renderComponent () {
                const blogPostData = this.myBlogPostData ? this.prepareBlogPostDataToRender(this.myBlogPostData) : null;

                let renderData = {
                    ...this.componentData,
                    data: blogPostData,
                };

                this.renderTemplate(renderData.template, renderData).then(output => {
                    if (!blogPostData) {
                        output = "<h2 style='font-size:30px'>Sorry this is not a blog post page</h2>";
                    }

                    this.componentNode.innerHTML = output;
                    this.renderingCompleted(renderData);
                });
            },
        },
        watch : {
            "myData": {
                deep: true,
                handler:function (newVal, oldVal) {
                    if (newVal.componentId) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            myBlogPostData: {
                handler (newVal, oldVal) {
                    if (newVal && typeof oldVal !== 'undefined') {
                        this.debouncedRenderComponent();
                    }
                },
                deep: true
            },
        },
    }
</script>
